// extracted by mini-css-extract-plugin
module.exports = {"pt-obs-department-detail":"pt-obs-department-detail-d0c2bee9e1189201e04ea71711abafc5"};